import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import { taskTemplateKeys } from '@core/react-query/features/tasks/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useAssignTaskTemplatesToProject = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['assignTaskTemplatesToProject']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectKeys.assignTaskTemplatesToProject,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(taskTemplateKeys.byOrganisation._def)
    },
  })
}
